<template>
  <div>
    <div>
      <div class="columns is-vcentered is-mobile">
        <div class="column is-narrow">
          <i class="fas fa-file fa-lg"></i>
        </div>
        <div class="column">
          <span><h3 class="title is-5">Dokumen</h3></span>
        </div>
        <div class="column is-narrow is-hidden-tablet">
          <a
            class=""
            @click="open = !open"
            aria-controls="contentIdForA11y1"
          >
            <i class="fas fa-caret-up" v-if="open"></i>
            <i class="fas fa-caret-down" v-else></i>
          </a>
        </div>
      </div>

      <b-collapse v-if="open" :open="open" aria-id="contentIdForA11y1" class="card-anggota" style="overflow: inherit;">
        <div class="columns is-multiline" id="box-files" v-for="(media, key) in medias" :key="key">
          <div class="column is-12-fullhd is-12-widescreen is-12-desktop is-12-tablet is-12-mobile" v-if="!isEmpty(medias)">
            <div class="card-download-right">
              <div class="type-file">
                <img :src="`/assets/img/icon/${media.extension}.svg`" alt="">
              </div>
              <div class="desc-file tooltip" :data-tooltip="media.name">
                <h3>{{ str_limit(media.name, 14) }}</h3>
                <span>{{ formatBytes(media.size) }}</span>
              </div>
              <a href="" @click.prevent="download(media, group.id)"
              target="_blank" rel="noopener"
              data-tooltip="Download" class="button is-small btn-download-small tooltip"
              >
              <span class="icon"><i class="fa fa-download"></i></span>
            </a>
          </div>
        </div>
      </div>

      <div class="columns" v-if="medias.length <= 0">
        <div class="column">
          <div class="card-download-right">
            <blockquote><p class="has-text-grey has-text-centered"><small>Tidak ada file ditemukan.</small></p></blockquote>
          </div>
        </div>
      </div>

      <div class="columns" v-if="medias.length > 0">
        <div class="column">
          <pagination v-if="!loading_get_medias" :dataProvider="mediaDataProvider" :clickHandler="getMedias"></pagination>
          <spinner-loading v-if="loading_get_medias"></spinner-loading>
        </div>
      </div>
    </b-collapse>
  </div>

  <br>
</div>
</template>

<script>
import { GROUP } from '~/consts';

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: true
    },
    group: {
      type: Object,
      required: true
    },
  },

  mounted() {
    this.getMedias();
  },

  data() {
    return {
      open: this.isOpen,
      loading_get_medias: false,
      medias: [],
      mediaDataProvider: {
        page: {
          current: 1,
          limit: 5,
        },
      },
    }
  },

  methods: {
    getMedias() {
      const vm = this;

      vm.loading_get_medias = true;

      this.$axios.post(GROUP.GET_MEDIAS(this.group.id), {
        dataProvider: JSON.stringify(vm.mediaDataProvider)
      })
      .then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          vm.medias = collect(vm.medias).merge(data.data.data).toArray();
          vm.mediaDataProvider = data.data.dataProvider
        }

        vm.loading_get_medias = false;
      }).catch(() => {
        vm.loading_get_medias = false;
      });
    },
  }
}
</script>
